function Footer() {
    return (
        <footer>
            <p>&copy; {new Date().getFullYear()} Digital Agency</p>
        </footer>
    )
}

export default Footer;